/**
 * The two Root folders a domain's uploads land in when the caller names no folder — one spelling for every
 * surface that saves into them.
 *
 * They live here because two libraries write into the same folders: the Uploads library — for the Domain files
 * panel's uploads and the chat's Document save — and the chat core, for the chat's image save. A folder is found or
 * created **by name**, so two spellings would be two folders.
 */

/** Ported from Clarity `apps/web/src/shared/api/domainFileStorageService.ts` (commit `9015ce88c`). */
export const CLARITY_UPLOADED_DOCUMENTS_FOLDER_NAME = 'Uploaded Documents';

/** Ported from Clarity `apps/web/src/shared/api/domainFileStorageService.ts` (commit `9015ce88c`). */
export const CLARITY_UPLOADED_IMAGES_FOLDER_NAME = 'Uploaded Images';
